import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Box, Typography, Button, Container } from "@mui/material";
import FormTextField from "../form/FormTextField";
import FormMultilineField from "../form/FormMultilineField";

const CompanyInfo = ({ csrfToken }) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [description, setDescription] = useState("");

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        setLoading(true);
        const res = await fetch("/api/company_info");
        if (!res.ok) throw new Error("会社情報の取得に失敗しました");
        const data = await res.json();
        setCompany(data);
        setDescription(data.business_description || "");
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompany();
  }, []);

  const handleUpdate = async () => {
    try {
      const res = await fetch("/api/company_info", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          company: {
            business_description: description,
          },
        }),
      });

      if (!res.ok) {
        const body = await res.json();

        throw new Error(body.errors?.join("\n") || "更新に失敗しました");
      }

      toast.success("更新しました。");
    } catch (e) {
      toast.error(e.message || "更新に失敗しました");
    }
  };

  if (loading) {
    return (
      <Box p={4} ml={4}>
        <Typography>読み込み中...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ pt: 3 }}>
        <Typography color="error">{error}</Typography>
      </Container>
    );
  }

  if (!company) return null;

  return (
    <Container maxWidth="md" sx={{ pt: 3 }}>
      <Typography variant="h5" mb={4} fontWeight="bold">
        会社情報
      </Typography>

      <Box display="flex" flexDirection="column" gap={3}>
        <FormTextField label="会社名" value={company.name || ""} disabled />

        <FormMultilineField
          label="事業内容（最大50文字まで）"
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="事業内容を入力してください"
          maxLength={50}
        />

        <FormTextField label="所在地" value={company.address || ""} disabled />

        <FormTextField
          label="メールアドレス"
          value={company.email || ""}
          disabled
        />

        <FormTextField
          label="電話番号"
          value={company.phone_number || ""}
          disabled
        />

        {/* 更新ボタン */}
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            color="inherit"
            onClick={handleUpdate}
            sx={{
              color: "#fff",
              bgcolor: "#000",
              "&:hover": { bgcolor: "#333" },
            }}
          >
            更新
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default CompanyInfo;
